__webpack_require__.p = "https://staticassets.goreact.com/eu-client/app/";